import React, { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as DangerIcon } from '../../../shared/icons/alert-danger-icon.svg';
import './document-wizard-header.scss';

interface DocumentSubeaderProps {
  actions: ReactNode;
  grantAccessSubheader?: boolean;
  unlockDocumentSubheader?: boolean;
  orgTemplateSubheader?: boolean;
  organizationName?: string;
  workspaceSharedSubheader?: boolean;
  workspaceName?: string;
  isClauseTemplate?: boolean;
}

export const DocumentSubheader = ({
  actions,
  grantAccessSubheader,
  unlockDocumentSubheader,
  orgTemplateSubheader,
  organizationName,
  workspaceSharedSubheader,
  workspaceName,
  isClauseTemplate,
}: DocumentSubeaderProps) => {
  const subHeaderStyleClass = () => {
    if (orgTemplateSubheader || workspaceSharedSubheader) {
      return 'document-wizard-subheader-warning';
    } else {
      return 'document-wizard-subheader-info';
    }
  };

  const subHeaderText = () => {
    if (grantAccessSubheader) {
      return 'Only your team has access to this document. Grant your counterparty access to allow them to view and download the document.';
    } else if (workspaceSharedSubheader) {
      const templateObject = isClauseTemplate ? 'clause' : 'template';
      return `This ${templateObject} is managed by ${workspaceName} workspace and cannot be edited here.`;
    } else if (orgTemplateSubheader) {
      const warningObject = isClauseTemplate ? 'Clause' : 'Template';

      return `This ${warningObject} is available due to your active membership in ${organizationName}, it cannot be edited.`;
    } else {
      return 'This is the last Approved version. Unlock to make edits.';
    }
  };
  return (
    <header className={subHeaderStyleClass()} data-testid="document-header">
      <nav className="document-wizard-header__actions-subheader">
        <div className="document-wizard-subheader__document-title-container">
          {unlockDocumentSubheader && (
            <span className="font-weight-bold pr-2">
              <FormattedMessage id="subheader-title" defaultMessage="Approved version." />
            </span>
          )}
          <DangerIcon width={15} height={15} />
          <FormattedMessage id="subheader-title" defaultMessage={subHeaderText()} />
        </div>
        {!orgTemplateSubheader && !workspaceSharedSubheader && (
          <div className="document-wizard-subheader__document-action-container">
            <div className="pr-1 document-wizard-header__edit-actions">{actions}</div>
          </div>
        )}
      </nav>
    </header>
  );
};
